<div class="row" style="margin-top: 5px;">
	<div class="col col-4">
		<span i18n="Include in offer|Title">Included in offer</span>:
	</div>
	<div class="col col-8">
		<input type="checkbox" size="none" style="width: 20px; height: 20px;" kendoCheckBox [(ngModel)]="inOffer" [disabled]="projectService.readOnly"/>
	</div>
</div>
